/**
 * Utility function to format time in M:SS format
 */
export const formatTime = (time: number): string => {
  const minutes = Math.floor(time / 60);
  const seconds = time % 60;
  return `${minutes}:${seconds.toString().padStart(2, '0')}`;
};

export const formatLanguageCode = (code: string | undefined): string => {
  if (!code) return 'DE';
  const shortCode = code.split('-')[0].toUpperCase();
  return shortCode;
};
